var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21719_151506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8.46005V9.96005C11.0006 10.0993 10.972 10.2371 10.9163 10.3647C10.8605 10.4923 10.7786 10.6068 10.676 10.701C10.5734 10.7951 10.4523 10.8668 10.3204 10.9114C10.1885 10.956 10.0487 10.9726 9.91 10.96C8.37141 10.7929 6.8935 10.2671 5.595 9.42505C4.38691 8.65738 3.36267 7.63313 2.595 6.42505C1.74999 5.12065 1.22412 3.63555 1.06 2.09005C1.0475 1.95178 1.06393 1.81243 1.10825 1.68086C1.15256 1.54929 1.22378 1.42839 1.31738 1.32586C1.41098 1.22332 1.5249 1.1414 1.65189 1.08531C1.77889 1.02922 1.91617 1.00018 2.055 1.00005H3.555C3.79765 0.99766 4.03289 1.08359 4.21688 1.24181C4.40086 1.40004 4.52104 1.61977 4.555 1.86005C4.61831 2.34008 4.73572 2.81141 4.905 3.26505C4.97227 3.44401 4.98683 3.63851 4.94695 3.82549C4.90707 4.01247 4.81443 4.1841 4.68 4.32005L4.045 4.95505C4.75677 6.20682 5.79322 7.24327 7.045 7.95505L7.68 7.32005C7.81594 7.18562 7.98757 7.09297 8.17456 7.0531C8.36154 7.01322 8.55603 7.02778 8.735 7.09505C9.18863 7.26432 9.65996 7.38174 10.14 7.44505C10.3829 7.47931 10.6047 7.60165 10.7633 7.7888C10.9218 7.97594 11.0061 8.21484 11 8.46005Z",
    stroke: "#6C757D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21719_151506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.12ac2d94598853bc1839249f0541ff03.svg";
export { ForwardRef as ReactComponent };